<template>
    <div class="rezultati-panel">
        <span class="pic icon-avatar-sample" :style="{'background-image': userData.avatar ? 'url(' + userData.avatar + ')' : ''}"></span>
        <p class="name"> {{userData.name ? userData.name : 'Nepoznati korisnik'}} </p>

        <div class="stats">
            <p class="stat border cf"><span>Točni odgovori</span><strong>{{ statistics.correct }}</strong></p>
            <p class="stat border cf"><span>Netočni odgovori</span><strong>{{ statistics.incorrect }}</strong></p>
            <p class="stat cf"><span>Ukupan rezultat</span><strong>{{ statistics.total }}</strong></p>
            <p class="stat cf"><span>U ovom kolu</span><strong>BODOVA</strong></p>
        </div>
    </div>
</template>

<script>

export default {
    name: 'rezultati-single-panel',
    computed: {
        uid () {
            try {
                return this.$route.params.uid
            } catch (error) { }
            return false
        },
        quizId () {
            try {
                return this.$route.params.quizId
            } catch (error) { }
            return false
        }
    },
    props: {
        statistics: Object,
        userData: Object
    }
}
</script>

<style lang="scss" scoped>
.rezultati-panel {
    position: relative;
    box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
    background-color: #fff;
    border-radius: 5px;
    padding: 54px 14px 9px;
    margin-top: 30px;

    .pic {
        display: block;
        position: absolute;
        left: calc(50% - 40px);
        top: -30px;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 5px solid #fff;
        background-color: #fff;
        background-position: 50%;
        background-size: cover;
    }
    .name {
        font-family: "axiforma";
        font-size: 16px;
        letter-spacing: .3px;
        color: #000;
        margin-bottom: 24px;
    }
    .stat {
        font-family: "axiforma";
        font-size: 16px;
        letter-spacing: 0px;
        color: #000;
        margin-bottom: 14px;

        span {
            display: block;
            float: left;
        }
        strong {
            display: block;
            float: right;
            font-family: "mPlus";
            font-size: 18px;
            font-weight: 800;
        }
    }
    .stat.border {
        border-bottom: 1px solid #d6d6d6;
        padding-bottom: 10px;
    }
    .stat:nth-child(2) {
        color: #ec2d4b;
        margin-bottom: 30px;
    }
    .stat:nth-child(3) {
        margin-bottom: 5px;
    }
    .stat:nth-child(4) {
        color: #adadae;
        font-size: 11px;
        font-weight: 700;
        margin-bottom: 0;

        strong {
            font-family: inherit;
            font-weight: 700;
            font-size: inherit;
        }
    }
}
</style>
